import axios from "axios";
import User from "../types/BackendUser";

const API_URL = process.env.REACT_APP_API_URL;

export const getAllUsers = async (opts?: {
  limit?: number;
  paginationToken?: string;
}) => {
  const params = new URLSearchParams();
  if (opts?.limit != null) params.set("limit", String(opts.limit));
  if (opts?.paginationToken) params.set("paginationToken", opts.paginationToken);
  const query = params.toString();
  const url = `${API_URL}/get-all-users${query ? `?${query}` : ""}`;
  const response = await axios.get(url, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
};

// Function to invite a new user
export const addUser = async (user: User) => {
  const response = await axios.post(`${API_URL}/invite-new-user`, user, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
  return response.data;
};

// Activate or decativate user (toggling user status)
export const toggleUserStatus = async (username: string) => {
  const response = await axios.post(
    `${API_URL}/toggle-user-status`,
    { username },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
  return response.data;
};

export const updateUser = async (user: User) => {
  const response = await axios.post(`${API_URL}/update-user`, user, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
  return response.data;
};

export const deleteUser = async (username: string) => {
  const response = await axios.post(
    `${API_URL}/delete-user`,
    { username },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
  return response.data;
};
